import { useMemo } from 'react';
import useGetFeatureFlagsAndSettings from './useGetFeatureFlagsAndSettings';

// variable for WebSocket debug logging (separate from feature enablement)
export const WEBSOCKET_DEBUG = process.env.NEXT_PUBLIC_WEBSOCKET_DEBUG === 'true';

export const useWebsocketFeature = (): boolean => {
  const { features } = useGetFeatureFlagsAndSettings();

  return useMemo(() => {
    return features?.enableWebsocketForRachelInbox || false;
  }, [features?.enableWebsocketForRachelInbox]);
};
